import { Button, Popover } from "antd";
import Paragraph from "antd/es/typography/Paragraph";

interface Props {
    label: string;
    value: string[]
    length?: number
}
const DetailltemMore = (props: Props) => {
    const { length = 3 } = props
    return (
        <div>
            <p className="text-[12px] text-[#475467] mb-0">{props.label}</p>
            <p className="text-[13px] font-[500] m-0 leading-[24px]">
                {
                    props?.value?.length > length ? (
                        <span>
                            {props?.value?.slice(0, length)?.join(", ")}{" "}
                            <Popover
                                trigger="hover"
                                placement="bottom"
                                content={(
                                    <Paragraph className='!mb-0 pl-[12px]'>
                                        <ul className="!mb-0">
                                            {props?.value?.map((item: any, index: number) => (
                                                <li className="text-[13px] font-[500] m-0" key={index}>
                                                    {item}
                                                </li>
                                            ))
                                            }
                                        </ul>
                                    </Paragraph>
                                )}  >
                                <Button type="link" size="small" className="!px-0 leading-[12px]">+{props?.value?.length - length} more</Button>
                            </Popover>
                        </span>

                    ) : (
                        props?.value?.join(", ")
                    )
                }
            </p>
        </div>
    )
}

export default DetailltemMore